import type { StateCreator } from "zustand";
import type { Command } from "@/lib/command/commands";
import {
  ClearCommand,
  EchoCommand,
  HelpCommand,
} from "@/lib/command/commands-terminal";
import type { Store } from "@/lib/store";
import type { CommandResult } from "@/lib/types";

export interface CommandsSlice {
  execute: (input: string) => CommandResult;
  listCommands: () => Command[];
}

export const createCommandsSlice: StateCreator<Store, [], [], CommandsSlice> = (
  _set,
  get,
) => {
  const registeredCommands: Map<string, Command> = new Map([
    ["clear", new ClearCommand()],
    ["help", new HelpCommand()],
    ["echo", new EchoCommand()],
  ]);

  function parseCommand(input: string): { name: string; args: string[] } {
    const parts = input.trim().split(/\s+/);
    const name = parts[0] ?? "";
    const args = parts.slice(1);
    return { name, args };
  }

  return {
    listCommands: (): Command[] => {
      return Array.from(registeredCommands.values());
    },
    execute: (input: string): CommandResult => {
      const { name, args } = parseCommand(input);

      if (name === "") {
        return { output: [], error: false };
      }

      const cmd = registeredCommands.get(name);

      if (!cmd) {
        return { output: [`${name}: command not found`], error: true };
      }

      try {
        return cmd.execute(args, get());
      } catch (error) {
        return {
          output: [`Error executing ${name}: ${error}`],
          error: true,
        };
      }
    },
  };
};
